(function () {
  function initFeaturedProducts(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.sd-featured-products');

    sections.forEach(function (section) {
      if (section.dataset.sdFeaturedProducts === 'true') {
        return;
      }

      section.dataset.sdFeaturedProducts = 'true';

      var viewport = section.querySelector('.sd-featured-products__viewport');
      var cards = section.querySelectorAll('.sd-featured-products-card');

      if (!viewport || !cards.length) {
        return;
      }

      section.addEventListener('click', function (event) {
        var button = event.target.closest('[data-featured-products-target]');

        if (!button || !section.contains(button)) {
          return;
        }

        var targetIndex = Number(button.dataset.featuredProductsTarget);
        var targetCard = cards[targetIndex];

        if (!targetCard) {
          return;
        }

        targetCard.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFeaturedProducts();
    });
  } else {
    initFeaturedProducts();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFeaturedProducts(event.target);
  });
})();
